module.exports = __webpack_public_path__ + "img/logo12com_desktop.e28bbf0f.png";